import { DividerContainer } from "./Divider.styled";

interface DividerProps {}

export const Divider = ({}: DividerProps) => {
	return <DividerContainer />;
};
